export const providerDisplayName = (providerName: string, providerNumber: string): string =>
  `${providerName} \u2014 ${providerNumber}`;
